var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "15",
        height: "9",
        viewBox: "0 0 15 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          id: "Vector",
          d: "M8.0853 0.333148L14.7604 7.00834C14.9149 7.16273 15 7.36882 15 7.58858C15 7.80833 14.9149 8.01443 14.7604 8.16882L14.2689 8.6604C13.9487 8.98027 13.4282 8.98027 13.1084 8.6604L7.50311 3.05508L1.89157 8.66662C1.73706 8.82101 1.53108 8.90625 1.31145 8.90625C1.09158 8.90625 0.885602 8.82101 0.730968 8.66662L0.239632 8.17504C0.0851202 8.02053 0 7.81455 0 7.5948C0 7.37504 0.0851202 7.16895 0.239632 7.01456L6.9208 0.333148C7.0758 0.178393 7.28275 0.0933943 7.50274 0.0938816C7.7236 0.0933943 7.93042 0.178393 8.0853 0.333148Z",
          fill: "white",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }